<script>
import RecycleModal from './Applicant/RecycleModal.vue'

export default {
	props: {
		requisition: {
			type: Object,
			required: true
		},
		jobApplications: {
			type: Array,
			required: true
		},
		phases: {
			type: Array,
			required: true
		},
		csrfToken: {
			type: String,
			required: true
		},
	},
	components: {
		RecycleModal
	},
	data() {
		return {
			searchTerm: '',
			selectedJobApplication: {}
		}
	},
	computed: {
		filteredApplications() {
			return this.jobApplications.filter(jobApplication => jobApplication.user.full_name.toLowerCase().includes(this.searchTerm.toLowerCase()))
		},
	},
	methods: {
		toggleModal(jobApplication) {
			this.selectedJobApplication = jobApplication
			this.$refs.recycleModal.toggleModal()
		},
		hardFail(event) {
			if (confirm("Are you sure you want to hard fail the candidate?")) {
				event.target.parentElement.submit();
			}

			event.returnValue = false;
			return false;
		},
		restore(event) {

			event.target.parentElement.submit();
			event.returnValue = false;
			return false;
		}
	},
	created() {
		toggleModal(this.jobApplications[0])
	}
}
</script>
<template>
	<div class="active-requisitions-table grid-x grid-padding-x grid-padding-y">
		<div class="cell shrink">
			<input type="text" v-model="searchTerm" placeholder="Filter by name..." class="mb-0" />
		</div>

		<div class="cell small-12">
			<table class="mb-4">
				<thead>
					<tr>
						<th>Name</th>
						<th>Surname</th>
						<th>Baseline Score</th>
						<th>Fail Step</th>
						<th>Requisition</th>
						<th>Fail Reason</th>
						<th>Action</th>
					</tr>
				</thead>

				<tbody>
					<tr v-for="jobApplication in filteredApplications" :key="jobApplication.id">
						<td>{{ jobApplication.user.first_name }}</td>
						<td>{{ jobApplication.user.last_name }}</td>
						<td>{{ (jobApplication.user.baseline_score !== null) ?
								jobApplication.user.baseline_score.satisfied_trait_count : ''
						}}</td>
						<td>
							<template v-for="(phase, index) in phases">
								<span class="badge" style="margin-right: 5px" :key="index"
									v-if="jobApplication[phase] && jobApplication[phase] == 'failed'">
									{{ phase.replaceAll('_', ' ').replace('status', '') }}
								</span>
							</template>
						</td>
						<td>{{ jobApplication.job.requisition.person_specification.title }}</td>
						<td>{{ jobApplication.fail_reason }}</td>
						<td>
							<form
								:action="`/recruiter/active-requisitions/restore/${jobApplication.id}/${requisition.id}`"
								method="POST" style="display: inline-block">
								<input type="hidden" name="_csrfToken" :value="csrfToken" />
								<a href="#" @click="restore">Restore to Requisition</a>
							</form>
							|
							<form
								:action="`/recruiter/active-requisitions/hard-fail/${jobApplication.id}/${requisition.id}`"
								method="POST" style="display: inline-block">
								<input type="hidden" name="_csrfToken" :value="csrfToken" />
								<a href="#" @click="hardFail">Hard Fail</a>
							</form>
							|
							<a :href="`/admin/users/impersonate/${jobApplication.user.id}`">Impersonate</a>
							|
							<a href="javascript:void(0)" @click="toggleModal(jobApplication)">Recycle</a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<recycle-modal ref="recycleModal" :job-application="selectedJobApplication" :csrf-token="csrfToken"
			:requisition-id="requisition.id" from="failBin" />
	</div>
</template>